var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { wrap: "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c(
            "v-card",
            { attrs: { rounded: "0" } },
            [
              _c(
                "v-card-title",
                { staticClass: "pb-0 mb-0", attrs: { "primary-title": "" } },
                [
                  _c("div", { staticClass: "text-h5 mb-0" }, [
                    _vm._v("Reference"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "v-card-title",
                { staticClass: "pt-0 mt-0", attrs: { "primary-title": "" } },
                [
                  _c("p", {
                    staticClass: "text-subtitle-2 mb-0",
                    domProps: { innerHTML: _vm._s(_vm.reference) },
                  }),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                "text-align": "center",
                color: "grey",
                "margin-top": "0.9rem",
                "font-size": "0.9rem",
              },
            },
            [
              _vm._v(
                "\n            The " +
                  _vm._s(_vm.$STRINGS.APP_NAME) +
                  " Server is proudly "
              ),
              _c(
                "a",
                {
                  staticStyle: { "text-decoration": "none", color: "darkgray" },
                  attrs: { href: _vm.$STRINGS.NAV_URL_1 },
                },
                [_vm._v("free and open-source software")]
              ),
              _vm._v(".\n        "),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }